"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OptionsTable_1 = __importDefault(require("../Tables/OptionsTable"));
const ParametresOptions = () => {
    return (react_1.default.createElement("div", { className: "row mb-4" },
        react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                react_1.default.createElement(OptionsTable_1.default, null)))));
};
exports.default = ParametresOptions;
